type Props = {
  rows?: number;
};

const Cell = ({ className }: { className: string }) => <div className={`h-3 animate-pulse bg-slate-200 ${className}`} />;

export const SlotRequestsTableSkeleton = ({ rows = 10 }: Props) => (
  <>
    {Array.from({ length: rows }).map((_, index) => (
      <tr key={index} className="odd:bg-white even:bg-slate-50">
        <td className="px-4 py-4"><Cell className="w-28" /></td>
        <td className="px-4 py-4"><Cell className="mb-2 w-40" /><Cell className="w-40" /></td>
        <td className="px-4 py-4"><Cell className="w-20" /></td>
        <td className="px-4 py-4"><Cell className="w-24" /></td>
        <td className="px-4 py-4"><Cell className="w-32" /></td>
        <td className="px-4 py-4"><Cell className="w-32" /></td>
        <td className="px-4 py-4"><Cell className="w-28" /></td>
        <td className="px-4 py-4"><Cell className="mx-auto w-9" /></td>
      </tr>
    ))}
  </>
);
